class BurstFiring {
    name;
    shortName;
    fireLimit;
    bulletsFired;
    /**
     * Logic for burst gun firing.
     * @param fireLimit The amount of bullets that can be fired in the burst.
     */
    constructor(fireLimit = 3) {
        this.name = "Burst";
        this.shortName = "burst";
        this.bulletsFired = 0;
        this.fireLimit = fireLimit;
    }
    /**
     * Increase the amount of bullets fired counter after a shot.
     */
    onShoot() {
        this.bulletsFired += 1;
    }
    /** Reset the amount of bullets fired counter when the player stops shooting. */
    onStopShooting() {
        this.bulletsFired = 0;
    }
    /**
     * Check whether the gun can fire or not.
     * @returns A boolean indicating whether the gun can be fired or not.
     */
    get canFire() {
        return this.bulletsFired < this.fireLimit;
    }
    get getShortName() {
        return this.shortName;
    }
    get getName() {
        return this.name;
    }
}
export { BurstFiring };
